import React, { useRef } from 'react';
import { useGlobalButtonPress } from '../hooks/useGlobalButtonPress';
import useLayoutOverflowWatch from '../hooks/useLayoutOverflowWatch';

/**
 * Wraps the dashboard shell so every native <button> gets a visible press state.
 */
export default function PressFeedbackRoot({ children, className = '', style }) {
  const rootRef = useRef(null);
  useGlobalButtonPress(rootRef);
  useLayoutOverflowWatch(rootRef);

  return (
    <div ref={rootRef} className={`app-ui-root ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}
